export default __webpack_public_path__ + "static/purchase-bg-desktop-ec7b2c6ee86b7c49ca3b29e2cc97707f.png";